import React from 'react';
import BuriedPermWrapper from '../BuriedWrapper/BuriedPermWrapper';
import DisableWrapper from '.';

/**
 * 体验环境只点击、埋点跟权限合并，只支持一个节点
 * @param {Object} props
 * @param {*} props.children
 * @param {string=} props.eventId
 * @param {string=} props.eventType
 * @param {string=} props.pageUrl
 * @param {string} props.resource 资源
 * @param {string=} props.triggerEvent 默认触发事件
 *  */
export default function DisableBuriedPermWrapper({ children, ...others }) {
  return (
    <DisableWrapper {...others}>
      <BuriedPermWrapper>{children}</BuriedPermWrapper>
    </DisableWrapper>
  );
}
